module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"799260423952459"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
